export default "__VITE_ASSET__vcGT7e7L__"